import {
  DeleteIfConversionRulesRequest,
  DeleteIfConversionRulesResponse,
  GetIfConversionRulesRequest,
  GetIfConversionRulesResponse,
  UpdateIfConversionRulesRequest,
  UpdateIfConversionRulesResponse,
  ifConversionRulesRestResource,
} from ".";
import { useRestResourceHook } from "../use-rest-resource-hook";

export const useGetIfConversionRules = () =>
  useRestResourceHook<
    GetIfConversionRulesRequest,
    GetIfConversionRulesResponse
  >((request) => ifConversionRulesRestResource.getIfConversionRules(request));

export const useUpdateIfConversionRules = () =>
  useRestResourceHook<
    UpdateIfConversionRulesRequest,
    UpdateIfConversionRulesResponse
  >((request) =>
    ifConversionRulesRestResource.updateIfConversionRules(request),
  );

export const useDeleteIfConversionRules = () =>
  useRestResourceHook<
    DeleteIfConversionRulesRequest,
    DeleteIfConversionRulesResponse
  >((request) =>
    ifConversionRulesRestResource.deleteIfConversionRules(request),
  );
